import React, { useEffect, useCallback } from 'react';
import { useChatStore } from '../../store/chatStore';
import ChatPanel from './ChatPanel';

const ChatWidget: React.FC = () => {
  const { isOpen, toggle, setOpen } = useChatStore();

  // Escape key to close — read isOpen inside handler to keep callback stable
  const handleKeyDown = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === 'Escape' && useChatStore.getState().isOpen) {
        setOpen(false);
      }
    },
    [setOpen]
  );

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [handleKeyDown]);

  return (
    <>
      {/* Floating terminal button */}
      {!isOpen && (
        <button
          onClick={toggle}
          className="fixed bottom-6 right-6 z-50 w-11 h-11 rounded-lg
            flex items-center justify-center
            bg-neutral-900 border border-neutral-700 text-neutral-400
            hover:text-neutral-200 hover:border-neutral-500
            hover:shadow-lg hover:shadow-black/30
            transition-all duration-150"
          title="Open Tesseract AI (terminal)"
        >
          <span className="font-mono text-sm font-bold">&gt;_</span>
        </button>
      )}

      {/* Chat panel — always dark terminal style */}
      {isOpen && (
        <div
          className="fixed bottom-0 right-0 z-50 w-[480px] h-[calc(100vh-64px)]
            flex flex-col shadow-2xl border-l border-neutral-800
            bg-[#0a0a0a] font-mono"
        >
          <ChatPanel />
        </div>
      )}
    </>
  );
};

export default ChatWidget;
